import { CaseStatus } from './types/enums';

export const FLIGHT_CASE_LIST_STATUS_FILTER_OPTIONS: CaseStatus[] = [
    CaseStatus.ON_HOLD,
    CaseStatus.PENDING,
    CaseStatus.IN_ANALYSIS,
];

export const DEFAULT_FLIGHT_CASE_LIST_STATUS_SELECTION: CaseStatus[] = [];

const API_CODE_BY_CASE_STATUS: Partial<Record<CaseStatus, string>> = {
    [CaseStatus.PENDING]: 'PENDING',
    [CaseStatus.ON_HOLD]: 'ON_HOLD',
    [CaseStatus.IN_ANALYSIS]: 'IN_ANALYSIS',
};

export function mapCaseStatusesToApiCodes(statuses: CaseStatus[]): string[] {
    return statuses
        .map((s) => API_CODE_BY_CASE_STATUS[s])
        .filter((c): c is string => c != null && c.length > 0);
}
